// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"44":"c908725a","123":"31d6cfe0","158":"9a1dac00","624":"850caa36"}[chunkId] + ".chunk.css";
};